module.exports = __webpack_public_path__ + "img/2bombas.69a1652e.jpg";